/**
 * Video Canvas
 *
 * Canvas helpers for extracting poster frames from video elements.
 */

class VideoCanvas {
    public static drawVideoFrame(video: HTMLVideoElement): string {
        const canvas = document.createElement("canvas");
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;

        const ctx = canvas.getContext("2d");
        if (!ctx) {
            return "";
        }

        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

        return canvas.toDataURL("image/jpeg", 0.8);
    }
}

export { VideoCanvas };
